module.exports = __webpack_public_path__ + "static/media/AC.c65aed4b.png";